import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '../../configuration/colors'

const EmptyBar = styled.div`
  height: 8px;
  width: ${props => (props.progressBarWidth ? props.progressBarWidth : '88px')};
  border-radius: 5px;
  background-color: ${colors.ash};
  overflow: hidden;
  position: relative;
  margin: 0 22px;
`

const ProgressBarContainer = styled.div`
  height: inherit;
  width: ${props => (props.progress.length < 1 ? '1px' : props.progress)}%;
  background: ${colors.jade};
`

export const ProgressBar = ({ progress, progressBarWidth }) => {
  return (
    <EmptyBar progressBarWidth={progressBarWidth}>
      <ProgressBarContainer progress={progress} />
    </EmptyBar>
  )
}

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  progressBarWidth: PropTypes.string
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/mini/ProgressBar.js